import { Box } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import { Modal } from '../../../../components'
import { SchedulingLinkTabPanel } from '../../../../components/PatientOrProviderDetails/Tabs/SchedulingLink.tab'
import { ProviderInformation } from '../../../../providers/ProviderDetails/types'

// Create interface for EditProviderModalProps
interface EditScheduleLinkModalProps {
  selectedScheduleProvider: ProviderInformation | null
  editScheduleLinkModal: boolean
  setEditScheduleLinkModal: React.Dispatch<React.SetStateAction<boolean>>
  onRefetchProvider: () => void
}

export const EditScheduleLinkModal = ({
  selectedScheduleProvider,
  editScheduleLinkModal,
  setEditScheduleLinkModal,
  onRefetchProvider,
}: EditScheduleLinkModalProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Modal
        open={editScheduleLinkModal}
        setOpen={setEditScheduleLinkModal}
        title={'Edit Schedule Links Visibility'}
        width={'30%'}
        ModalContent={
          <Box sx={{ width: '92%', margin: 'auto' }}>
            <SchedulingLinkTabPanel
              primaryScheduleLink={
                selectedScheduleProvider?.primaryGRemindersLink
              }
              //@ts-ignore
              scheduleLinks={selectedScheduleProvider?.gRemindersEventTypeLinks}
              onUpdate={onRefetchProvider}
            />
          </Box>
        }
      />
    </LocalizationProvider>
  )
}
